import * as actionTypes from './types';


const INITIAL_KEY_STATE = {
	value: null
};

const INITIAL_STATE = {
	value: {
		visible: false,
		isThemeAvailable: false,
		isGuestTokenReady: false,
		theme: 'universal',
		primary: '',
		secondary: '',
		template: 'food',
		darkLogo: '',
		lightLogo: '',
		favIcon: '',
		currency: '₹',
		role: 'Reader',
		language: 'en-US',
		header: true,
		footer: true,
		sidebar: true,
		tenantName: 'agri',
		tenantId: -1, // DO NOT CHANGE THE VALUE
		getQuote: 'close',
		getUploadFiles: 'close',
		getCommonModal: 'close',
		getReturnModal: 'close',
		getDeleteModal: 'close',
		getUploadModal: 'close',
		getResetModal: 'close',
		getFulifllmentOrderCommonModal: 'close',
		getAssociatedProductModal: 'close',
	},
	set: INITIAL_KEY_STATE,
};


const settingsReducer = (state = INITIAL_STATE, action: any) => {
	const { payload } = action;
	switch (action.type) {
		case actionTypes.SET_DATA:

			return {
				value: {
					...state.value,
					...payload
				}
			};
		default:
			return state;
	}
};

export default settingsReducer;
